import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// MUI Imports
import { Tooltip, tooltipClasses } from "@mui/material";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// COMPONENETS Imports
import Footer from "../../../../components/LandingPage/Footer";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";

// SVG Import
import BackToTop from "../../../../assets/landingPage/TopArrow.svg";
import ICONS from "../../../../assets/Icons/index.js";

const ContactUs = () => {
  // useState
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [location, setLocation] = useState("mumbaiHead");

  const locations = {
    mumbaiHead:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3451.8779791938423!2d72.83196553488769!3d19.061905799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9e5d90b55e5%3A0x5405fcb4888919ab!2sQ2Pay%20Technologies%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1774605109402!5m2!1sen!2sin",
    mumbai:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1885.6372328408952!2d72.83027633591264!3d19.05166649798471!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c93f3228b1d9%3A0x3bbcfaf779efad37!2sMumbai%20Educational%20Trust%20(MET)!5e0!3m2!1sen!2sin!4v1750320664683!5m2!1sen!2sin",
    pune: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3462.343957875147!2d73.7744179829855!3d18.552596999154677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf4ed799eba1%3A0xd54baaeff505af5f!2sAmbrosia%20Galaxy!5e1!3m2!1sen!2sin!4v1774604920044!5m2!1sen!2sin",
  };
  const addresses = {
    mumbaiHead: `Mumbai - Fifth floor, Cozy Nook 30, 36 cross, Linking Rd, opposite Bademiya,<br/> Khar, Bandra West, Mumbai, Maharashtra 400050`,
    mumbai: `Mumbai - <span style={{"whiteSpace: nowrap;}}">7<sup>th</sup></span> floor A wing, Mumbai Educational Trust (MET, Bhujbal Knowledge City, opposite Lilavati Hospital, Reclamation, Bandra West, Mumbai, Maharashtra 400050`,
    pune: `Pune - Q2Pay Technologies Private Limited,  <span style={{"whiteSpace: nowrap;}}">17<sup>th</sup></span>  Floor, Ambrosia Galaxy, 33/1, Hill Road, Baner, Pune - 411069`,
  };

  const addressChangeData = () => {
    const address = addresses[location];
    const [city, ...rest] = address.split(" - ");
    const formattedCity = city
      .replace(
        "Mumbai",
        `<span style="color: var(--pending); font-weight: var(--font-semibold);">Mumbai</span>`,
      )
      .replace(
        "Pune",
        `<span style="color: var(--pending); font-weight: var(--font-semibold);">Pune</span>`,
      );
    const plainAddress = address.replace(/<\/?[^>]+(>|$)/g, "");

    return (
      <Tooltip
        componentsProps={{
          popper: {
            sx: {
              [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: (theme) => theme.palette.common.black,
              },
              zIndex: "2147483647 !important",
            },
          },
        }}
        title={plainAddress}
      >
        <p
          className="line-clamp-3 text-center text-xs"
          dangerouslySetInnerHTML={{
            __html: `${formattedCity} - ${rest.join(" - ")}`,
          }}
        />
      </Tooltip>
    );
  };

  // useSelector
  const { webstatus } = useSelector((state) => state.landingpagestate);

  // useEffect

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    });
  }, [scrollPercent]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };
  }, []);

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "34px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}
        <div
          className="bg-[#031f4f] min-h-screen scrollbar-none flex flex-col"
          style={{
            overflow: webstatus ? "hidden" : "",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div className="flex flex-col justify-center bg-[#1D3A6D] text-text-primary">
            <div
              className="flex flex-col justify-center lg:items-center relative mt-[88px] 
              lg:mt-0 px-4
              lg:px-0 lg:pt-[88px] lg:flex-1 relative"
            >
              <div className="text-left lg:text-center">
                <h2
                  className="text-font-md lg:text-font-xl font-semibold
                    pb-padding-xs lg:pb-2 text-text-primary"
                >
                  Get in <span className="text-pending">touch</span>
                </h2>

                <p
                  className="text-text-secondary text-sm lg:text-xs pb-padding-sm lg:pb-0
                  font-semibold lg:font-normal"
                >
                  Contact us for a quote or any help if needed.
                </p>
              </div>

              <div
                className="w-full lg:w-screen lg:max-w-[1440px] mx-auto relative flex
                lg:flex-col items-center w-width-full pt-0 py-padding-md lg:py-padding-md 
                lg:h-full"
              >
                <div
                  className="w-full max-w-tab-width-normal flex flex-col lg:flex-row 
                justify-center items-center lg:items-stretch gap-y-5 lg:gap-x-gap-md"
                >
                  <div
                    className="w-full lg:w-[155px] flex flex-row lg:flex-col items-stretch
                      lg:items-center gap-x-[20px] lg:gap-x-0 lg:space-y-4 lg:flex-shrink-0"
                  >
                    <button
                      className={`p-padding-sm lg:px-4 lg:py-2 rounded-border-radius-sm lg:rounded-lg w-full 
                        lg:min-h-[37px] lg:w-[155px] text-xs lg:leading-[unset]
                         ${
                           location === "mumbaiHead"
                             ? "bg-text-primary text-[#000000] font-semibold"
                             : "bg-[#3A5686] text-text-primary"
                         }`}
                      onClick={() => setLocation("mumbaiHead")}
                    >
                      Mumbai - Head office
                    </button>

                    <button
                      className={`p-padding-sm lg:px-4 lg:py-2 rounded-border-radius-sm lg:rounded-lg w-full 
                        lg:min-h-[37px] lg:w-[155px] text-xs lg:leading-[unset] ${
                          location === "mumbai"
                            ? "bg-text-primary text-[#000000] font-semibold"
                            : "bg-[#3A5686] text-text-primary"
                        }`}
                      onClick={() => setLocation("mumbai")}
                    >
                      Mumbai - Branch office
                    </button>

                    <button
                      className={`p-padding-sm lg:px-4 lg:py-2 rounded-border-radius-sm lg:rounded-lg w-full 
                        lg:min-h-[37px] lg:w-[155px] text-xs lg:leading-[unset] ${
                          location === "pune"
                            ? "bg-text-primary text-[#000000] font-semibold"
                            : "bg-[#3A5686] text-text-primary "
                        }`}
                      onClick={() => setLocation("pune")}
                    >
                      Pune - Branch office
                    </button>
                  </div>

                  <div
                    className="w-full flex flex-col lg:flex-row items-stretch gap-y-4 
                  lg:gap-x-[20px]"
                  >
                    <div
                      className="w-full lg:w-width-sm-1-3 h-auto gap-gap-sm p-4 lg:p-padding-sm
                        flex flex-col items-center justify-center border
                        border-pending rounded-xl text-text-primary"
                    >
                      <SVGComponent
                        url="https://q2pay.in/new_assets/common/detail_page/address.svg"
                        height="var(--icon-lg)"
                        width="var(--icon-lg)"
                      />

                      {addressChangeData()}
                    </div>

                    <div className="hidden lg:block border-r-[1px] border-pending"></div>

                    <div
                      className="w-full lg:w-width-sm-1-3 h-auto gap-gap-sm
                        p-4 lg:p-padding-sm flex flex-col items-center justify-center
                        border border-pending rounded-xl text-text-primary"
                    >
                      <SVGComponent
                        url={ICONS?.CONTACT_WITH_WHITE_CIRCLE}
                        height="var(--icon-lg)"
                        width="var(--icon-lg)"
                      />

                      <p className="text-xs Qlg:text-font-xxs lg:leading-[unset]">
                        +91 90044 00700
                      </p>
                    </div>

                    <div className="hidden lg:block border-r-[1px] border-pending"></div>

                    <div
                      className="w-full lg:w-width-sm-1-3 h-auto gap-gap-sm
                        p-4 lg:p-padding-sm flex flex-col items-center justify-center
                        border border-pending rounded-xl text-text-primary"
                    >
                      <SVGComponent
                        url={ICONS?.CONTACT_US_MAIL}
                        height="var(--icon-lg)"
                        width="var(--icon-lg)"
                      />

                      <p className="text-xs Qlg:text-font-xxs lg:leading-[unset]">
                        <a
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=support@q2pay.in"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                        >
                          support@q2pay.in
                        </a>
                      </p>

                      <p className="text-xs Qlg:text-font-xxs lg:leading-[unset]">
                        <a
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@q2pay.in"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                        >
                          sales@q2pay.in
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full max-w-tab-width-normal mb-margin-lg">
                <iframe
                  title="location"
                  src={locations[location]}
                  width="100%"
                  height="400"
                  style={{
                    border: 0,
                    borderRadius: "10px",
                  }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
